"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var roosterjs_editor_dom_1 = require("roosterjs-editor-dom");
/**
 * A content edit feature to trigger EntityOperation event with operation "Click" when user
 * clicks on a readonly entity.
 */
var ClickOnEntityFeature = {
    keys: [13 /* ENTER */],
    shouldHandleEvent: function (event, editor) { return cacheGetReadonlyEntityElement(event, editor); },
    handleEvent: function (event, editor) {
        cacheGetReadonlyEntityElement(event, editor, 1 /* Click */);
    },
};
/**
 * A content edit feature to trigger EntityOperation event with operation "Escape" when user
 * presses ESC on a readonly entity.
 */
var EscapeFromEntityFeature = {
    keys: [27 /* ESCAPE */],
    shouldHandleEvent: function (event, editor) { return cacheGetReadonlyEntityElement(event, editor); },
    handleEvent: function (event, editor) {
        cacheGetReadonlyEntityElement(event, editor, 3 /* Escape */);
    },
};
function cacheGetReadonlyEntityElement(event, editor, operation) {
    var element = roosterjs_editor_dom_1.cacheGetEventData(event, 'READONLY_ENTITY_ELEMENT', function () {
        var node = event.rawEvent.target;
        var entityElement = node && editor.getElementAtCursor(roosterjs_editor_dom_1.getEntitySelector(), node);
        return entityElement && !entityElement.isContentEditable ? entityElement : null;
    });
    if (element && operation !== undefined) {
        editor.triggerPluginEvent(15 /* EntityOperation */, {
            operation: operation,
            rawEvent: event.rawEvent,
            entity: roosterjs_editor_dom_1.getEntityFromElement(element),
        });
    }
    return element;
}
/**
 * A content edit feature to split current line into two lines at the cursor when user presses
 * ENTER right before a readonly entity.
 * Browser's default behavior will insert an extra BR tag before the entity which causes an extra
 * empty line. So we override the default behavior here.
 */
var EnterBeforeReadonlyEntityFeature = {
    keys: [13 /* ENTER */],
    shouldHandleEvent: function (event, editor) {
        return cacheGetNeighborEntityElement(event, editor, true /*isNext*/, false /*collapseOnly*/);
    },
    handleEvent: function (event, editor) {
        var _a;
        event.rawEvent.preventDefault();
        var range = editor.getSelectionRange();
        var node = roosterjs_editor_dom_1.Position.getEnd(range).normalize().node;
        var br = editor.getDocument().createElement('BR');
        node.parentNode.insertBefore(br, node.nextSibling);
        var block = editor.getBlockElementAtNode(node);
        var newContainer;
        if (block) {
            newContainer = block.collapseToSingleElement();
            (_a = br.parentNode) === null || _a === void 0 ? void 0 : _a.removeChild(br);
        }
        editor.getSelectionRange().deleteContents();
        if (newContainer.nextSibling) {
            editor.select(newContainer.nextSibling, 0 /* Begin */);
        }
    },
};
/**
 * A content edit feature to trigger EntityOperation event with operation "RemoveFromEnd" when user
 * press BACKSPACE right after an entity
 */
var BackspaceAfterEntityFeature = {
    keys: [8 /* BACKSPACE */],
    shouldHandleEvent: function (event, editor) {
        return cacheGetNeighborEntityElement(event, editor, false /*isNext*/, true /*collapseOnly*/);
    },
    handleEvent: function (event, editor) {
        cacheGetNeighborEntityElement(event, editor, false /*isNext*/, true /*collapseOnly*/, 5 /* RemoveFromEnd */);
    },
};
/**
 * A content edit feature to trigger EntityOperation event with operation "RemoveFromStart" when user
 * press DELETE right after an entity
 */
var DeleteBeforeEntityFeature = {
    keys: [46 /* DELETE */],
    shouldHandleEvent: function (event, editor) {
        return cacheGetNeighborEntityElement(event, editor, true /*isNext*/, true /*collapseOnly*/);
    },
    handleEvent: function (event, editor) {
        cacheGetNeighborEntityElement(event, editor, true /*isNext*/, true /*collapseOnly*/, 4 /* RemoveFromStart */);
    },
};
function cacheGetNeighborEntityElement(event, editor, isNext, collapseOnly, operation) {
    var element = roosterjs_editor_dom_1.cacheGetEventData(event, 'NEIGHBOR_ENTITY_ELEMENT_' + isNext + '_' + collapseOnly, function () {
        var range = editor.getSelectionRange();
        if (collapseOnly && !range.collapsed) {
            return null;
        }
        range.commonAncestorContainer.normalize();
        var pos = roosterjs_editor_dom_1.Position.getEnd(range).normalize();
        var isAtBeginOrEnd = pos.offset == 0 || pos.isAtEnd;
        var entityNode = null;
        if (isAtBeginOrEnd) {
            var traverser = editor.getBodyTraverser(pos.node);
            var sibling = isNext
                ? pos.offset == 0
                    ? traverser.currentInlineElement
                    : traverser.getNextInlineElement()
                : pos.isAtEnd
                    ? traverser.currentInlineElement
                    : traverser.getPreviousInlineElement();
            var node = sibling && sibling.getContainerNode();
            if (!collapseOnly) {
                var block = editor.getBlockElementAtNode(pos.node);
                if (!block || !block.contains(node)) {
                    node = null;
                }
            }
            entityNode = node && editor.getElementAtCursor(roosterjs_editor_dom_1.getEntitySelector(), node);
        }
        return entityNode;
    });
    if (element && operation !== undefined) {
        editor.triggerPluginEvent(15 /* EntityOperation */, {
            operation: operation,
            rawEvent: event.rawEvent,
            entity: roosterjs_editor_dom_1.getEntityFromElement(element),
        });
    }
    return element;
}
/**
 * @internal
 */
exports.EntityFeatures = {
    clickOnEntity: ClickOnEntityFeature,
    escapeFromEntity: EscapeFromEntityFeature,
    enterBeforeReadonlyEntity: EnterBeforeReadonlyEntityFeature,
    backspaceAfterEntity: BackspaceAfterEntityFeature,
    deleteBeforeEntity: DeleteBeforeEntityFeature,
};
//# sourceMappingURL=entityFeatures.js.map